import { useMemo } from 'react'
import type { NavItem, CategoryItem, TopBarInfo } from '../model/types'
import { useAdminCategoriesStore } from '@/modules/admin/state/categoriesStore'
import { useSettings } from '@/modules/settings-api'

export const TOP_BAR_ITEMS: TopBarInfo[] = [
  { label: 'Miễn phí vận chuyển toàn quốc', icon: 'truck' },
  { label: 'Bảo hành chính hãng 3 năm', icon: 'shield-check' },
  { label: 'Hỗ trợ 24/7: 1800 1234', icon: 'headphones' },
]

export function useTopBarItems(): TopBarInfo[] {
  const { data: settings } = useSettings()
  return useMemo(() => [
    { label: 'Miễn phí vận chuyển toàn quốc', icon: 'truck' },
    { label: `Bảo hành chính hãng ${Math.round(settings.warrantyMonths / 12)} năm`, icon: 'shield-check' },
    { label: `Hỗ trợ 24/7: ${settings.hotline}`, icon: 'headphones' },
  ], [settings.hotline, settings.warrantyMonths])
}

export const MAIN_NAV: NavItem[] = [
  { label: 'Trang chủ', to: '/' },
  { label: 'Xe máy điện', to: '/danh-muc/xe-may-dien' },
  { label: 'Xe đạp điện', to: '/danh-muc/xe-dap-dien' },
  { label: 'Phụ kiện', to: '/danh-muc/phu-kien' },
  { label: 'Tin tức', to: '/tin-tuc', hasDropdown: true },
  { label: 'Khuyến mãi', to: '/khuyen-mai' },
  { label: 'Liên hệ', to: '/lien-he' },
]

export function useLiveCategories(): CategoryItem[] {
  const categories = useAdminCategoriesStore((s) => s.categories)
  return useMemo(
    () => categories
      .slice()
      .sort((a, b) => a.order - b.order)
      .map((c) => ({ label: c.label, to: `/danh-muc/${c.slug}`, icon: c.icon })),
    [categories],
  )
}

export const CATEGORIES: CategoryItem[] = [
  { label: 'Xe máy điện', to: '/danh-muc/xe-may-dien', icon: 'bike' },
  { label: 'Xe đạp điện', to: '/danh-muc/xe-dap-dien', icon: 'bike' },
  { label: 'Xe tay ga điện', to: '/danh-muc/xe-tay-ga-dien', icon: 'bike' },
  { label: 'Xe thể thao điện', to: '/danh-muc/xe-the-thao-dien', icon: 'bike' },
  { label: 'Phụ kiện xe điện', to: '/danh-muc/phu-kien', icon: 'wrench' },
  { label: 'Pin & Sạc điện', to: '/danh-muc/pin-sac', icon: 'battery-charging' },
  { label: 'Đồ bảo hộ', to: '/danh-muc/do-bao-ho', icon: 'shield' },
]
